import axios from "axios"
import React, { useEffect, useState } from "react"
import API from "../../Common/API"
import { motion } from 'framer-motion'
import profession from '../../Assets/Icons/profession.svg'
import income from '../../Assets/Icons/income.svg'
import date from '../../Assets/Icons/date.svg'
import stars from '../../Assets/Icons/star.svg'
import workLocation from '../../Assets/Icons/workLocation.svg'
import flawsIcon from '../../Assets/Icons/flaws.svg'
import { FaGraduationCap } from "react-icons/fa6";
import { TbZodiacCancer } from "react-icons/tb";
import RasiKattam from "../../Components/RasiKattam"
import AmsaKattam from "../../Components/AmsaKattam"
import FieldInputLoader from "../../Components/Loaders/FieldInputLoader"
import PreviewProfileLoader from "../../Components/Loaders/PreviewProfileLoader"

const PreviewRegistration = ({ registerValues }) => {

    const userDetails = registerValues
    const [educationList, setEducationList] = useState([]);
    const [fullEducations, setFullEducations] = useState([])
    const [zodiacSigns, setZodiacSigns] = useState([])
    const [flaws, setFlaws] = useState([])
    const [occupation, setOccupation] = useState([])
    const [allStars, setAllStars] = useState([])
    const [status, setStatus] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        try {
            axios.all([API.get('/common/getEducations'), API.get('/common/getZodiacSign'), API.get('/common/getAllFlaws'), API.get('/common/getStatusList'), API.get('/common/getOccupations'), API.get('/common/getAllStars')]).then((axios.spread((eduRes, zodiacRes, flawRes, statRes, occuRes, starRes) => {
                setEducationList(eduRes.data.data.map((c) => { return { text: `${c.education} ${c.specialization !== null ? `- ${c.specialization}` : ''}`, value: c._id } }))
                setFullEducations(eduRes.data.data)
                setZodiacSigns(zodiacRes.data.data.map((c) => { return { text: `${c.zodiacSign}`, value: c._id } }))
                setFlaws(flawRes.data.data.map((c) => { return { text: c.flawName, value: c._id } }))
                setStatus(statRes.data.data.map((c) => { return { text: c.status, value: c._id } }))
                setOccupation(occuRes.data.data)
                setAllStars(starRes.data.data.map((c) => { return { text: c.star, value: c._id } }))
                setLoading(false)
            })))
        } catch (err) {
            console.log(err)
        }
    }, [])

    const calculateAge = (birthdate) => {
        const today = new Date();
        const birthDate = new Date(birthdate);
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();

        // If birth month is after current month or same month but birth date is after current date, subtract 1
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age;
    };

    const getFlaws = (value) => {
        return flaws.filter((x) => x.value === value)[0].text
    }

    const getStatus = (value) => {
        return status.filter((x) => x.value === value)[0].text
    }

    const getZodiac = (value) => {
        return zodiacSigns.filter((x) => { return x.value === value })[0].text
    }

    const getStars = (value) => {
        return allStars.filter((x) => { return x.value === value })[0].text
    }

    const getQualification = (value) => {
        return educationList.filter((x) => { return x.value === value })[0].text
    }

    return (
        <>
            {loading ? (
                <PreviewProfileLoader />
            ) : (
                <motion.div className="min-h-screen w-full flex flex-col relative px-2 py-2">
                    {/* Basic Profile Details */}
                    <motion.div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 justify-start gap-5">
                        {/* User Uploaded Images */}
                        <motion.div className="flex flex-col h-full gap-2 w-96">
                            <motion.div>
                                {userDetails?.previewUrls && userDetails.previewUrls[0] && (
                                    <img src={userDetails.previewUrls[0]} className="h-96 w-96 object-cover" alt="Preview" />
                                )}
                            </motion.div>
                            <motion.div className="flex flex-row gap-1 w-96 overflow-x-scroll">
                                {userDetails?.previewUrls && userDetails.previewUrls.map((c) => {
                                    return <img src={c} height={100} width={100} className="object-cover" alt={'Preview'} />
                                })}
                            </motion.div>
                        </motion.div>
                        {/* User Details */}
                        <motion.div className="flex flex-col h-full w-full gap-3">
                            <p className="text-2xl font-bold text-primeColor">{userDetails.firstName}&nbsp;{userDetails.lastName} ({userDetails.surname}) </p>
                            <p className="flex flex-row flex-wrap text-xl font-bold justify-start gap-2 items-center"><img src={profession} alt="profession" />{userDetails.occupationDetail}<span className="text-greyColor items-center font-bold text-3xl">|</span>{calculateAge(userDetails.dateOfBirth)} Years Old <span className="text-greyColor items-center font-bold text-3xl">|</span>{userDetails.heightInFeet || '-'}</p>
                            <p className="flex flex-row text-lg  flex-wrap justify-start gap-2 items-center"><img src={date} alt="income" height={30} width={30} />Date Of Birth<span className="text-primeColor items-center font-bold text-lg">{userDetails.dateOfBirth}</span></p>
                            <p className="flex flex-row text-lg  flex-wrap justify-start gap-2 items-center"><img src={income} alt="income" height={30} width={30} />Income/{userDetails.salaryMode ? userDetails.salaryMode : 'Month'}<span className="text-primeColor items-center font-bold text-lg">{userDetails.salary}</span></p>
                            <p className="flex flex-row text-lg  flex-wrap justify-start gap-2 items-center"> <FaGraduationCap className="mx-1" size={20} />Qualification <span className="text-primeColor items-center font-bold text-lg">{userDetails.otherEducationalQualification}</span></p>
                            <p className="flex flex-row text-lg  flex-wrap justify-start gap-2 items-center"><img src={workLocation} alt="building" height={30} width={30} />Work Location<span className="text-primeColor items-center font-bold text-lg">{userDetails.occupationLocation}</span></p>
                            <p className="flex flex-row text-lg  flex-wrap justify-start gap-2 items-center"> <TbZodiacCancer className="mx-1" size={20} />Zodia Sign <span className="text-primeColor items-center font-bold text-lg">{zodiacSigns.filter((x) => x.value === userDetails.additionalInformation.zodiacSign)[0].text}</span></p>
                            <p className="flex flex-row text-lg  flex-wrap justify-start gap-2 items-center"> <img src={stars} alt="workLocatino" height={30} width={30} />Star <span className="text-primeColor items-center font-bold text-lg">{allStars.filter((x) => x.value === userDetails.additionalInformation.star)[0].text}</span></p>
                            <p className="flex flex-row text-lg  flex-wrap justify-start gap-2 items-center"> <img src={flawsIcon} alt="workLocatino" height={30} width={30} />Flaws <span className="text-primeColor items-center font-bold text-lg">{userDetails.additionalInformation.flaws.map((c) => { return getFlaws(c) })}</span></p>
                            <motion.div className="flex flex-col gap-5">
                                <p className="text-2xl font-bold text-primeColor">Expected Occupation</p>
                                <motion.div className="relative flex flex-row justify-start flex-wrap gap-2">
                                    {
                                        userDetails.additionalInformation.expectedOccupation.map((occu, i) => {
                                            return <motion.div className="w-fit px-2 py-1 rounded-full border border-primeColor bg-primeColor/20 text-primeColor font-bold">
                                                {occupation.filter((x) => x._id === occu)[0].occupation}
                                            </motion.div>
                                        })
                                    }
                                </motion.div>
                            </motion.div>
                        </motion.div>
                    </motion.div>
                    <motion.div className="flex flex-row flex-wrap justify-start px-1 md:px-5 md:overflow-hidden relative w-full gap-5 my-2">
                        <motion.div className="flex flex-col gap-5 w-fit px-2 py-2 relative">
                            <p className="text-xl font-bold text-primeColor">Family Information</p>
                            <motion.div className="grid grid-cols-2">
                                <p>Father name</p>
                                <p className="font-bold text-primeColor">{userDetails.familyInformation.fatherFirstName}&nbsp;{userDetails.familyInformation.fatherLastName}&nbsp;({userDetails.familyInformation.fatherSurname})</p>
                            </motion.div>
                            <motion.div className="grid grid-cols-2">
                                <p>Father Occupation</p>
                                <p className="font-bold text-primeColor">{occupation.filter((x) => x._id === userDetails.familyInformation.fatherOccupation)[0].occupation}</p>
                            </motion.div>
                            <motion.div className="grid grid-cols-2">
                                <p>Mother name</p>
                                <p className="font-bold text-primeColor">{userDetails.familyInformation.motherFirstName}&nbsp;{userDetails.familyInformation.motherLastName}&nbsp;({userDetails.familyInformation.motherSurname})</p>
                            </motion.div>
                            <motion.div className="grid grid-cols-2">
                                <p>Mother Occupation</p>
                                <p className="font-bold text-primeColor">{occupation.filter((x) => x._id === userDetails.familyInformation.motherOccupation)[0].occupation}</p>
                            </motion.div>
                            <motion.div className="grid grid-cols-2">
                                <p>Number of Siblings</p>
                                <p className="font-bold text-primeColor">{userDetails.familyInformation.numberOfSiblings}</p>
                            </motion.div>
                            <motion.div className="grid grid-cols-2">
                                <p>Male Siblings</p>
                                <p className="font-bold text-primeColor">{userDetails.familyInformation.numberOfMaleSiblings}</p>
                            </motion.div>
                            <motion.div className="grid grid-cols-2">
                                <p>Female Siblings</p>
                                <p className="font-bold text-primeColor">{userDetails.familyInformation.numberOfFemaleSiblings}</p>
                            </motion.div>
                        </motion.div>
                        <div className="h-auto w-[1px] lg:block hidden  bg-primeColor"></div>
                        <motion.div className="flex flex-col gap-5 w-fit px-2 py-2 relative">
                            <p className="text-xl font-bold text-primeColor">Contact Information</p>
                            <motion.div className="grid grid-cols-2">
                                <p>Phone Number</p>
                                <p className="font-bold text-primeColor">{userDetails.contactInformation.mobileNumber}</p>
                            </motion.div>
                            <motion.div className="grid grid-cols-2">
                                <p>Email Id</p>
                                <p className="font-bold text-primeColor">{userDetails.contactInformation.email || '-'}</p>
                            </motion.div>
                            <motion.div className="grid grid-cols-2">
                                <p>Address</p>
                                <p className="font-bold text-primeColor">{userDetails.contactInformation.presentAddress.addressLine1},</p>
                                {userDetails.contactInformation.presentAddress.addressLine2 && <><br /><p className="font-bold text-primeColor">{userDetails.contactInformation.presentAddress.addressLine2},</p></>}
                                <br />
                                <p className="font-bold text-primeColor">{userDetails.contactInformation.presentAddress.city},</p>
                                <br />
                                <p className="font-bold text-primeColor">{userDetails.contactInformation.presentAddress.district} - {userDetails.contactInformation.presentAddress.pinCode}</p>
                                <br />
                                <p className="font-bold text-primeColor">{userDetails.contactInformation.presentAddress.state}</p>
                            </motion.div>
                        </motion.div>
                        <div className="h-auto w-[1px] lg:block hidden bg-primeColor"></div>
                        <motion.div className="flex flex-col gap-5 w-fit px-2 py-2 relative">
                            <p className="text-xl font-bold text-primeColor">Expected Information</p>
                            <motion.div className="grid w-96 grid-cols-2">
                                <p>Income/Month</p>
                                <p className="font-bold text-primeColor">{userDetails.additionalInformation.expectedSalary || '-'}</p>
                            </motion.div>
                            <motion.div className="grid w-96 grid-cols-2">
                                <p>Status</p>
                                <p className="font-bold text-primeColor">{userDetails.additionalInformation.expectedStatus.map((c, i) => { return <>{getStatus(c)}{i !== userDetails.additionalInformation.expectedStatus.length - 1 && ','}&nbsp;</> })}</p>
                            </motion.div>
                            <motion.div className="grid w-96 grid-cols-2">
                                <p>Zodiac Signs</p>
                                <p className="font-bold text-primeColor">{userDetails.additionalInformation.expectedZodiacSigns.map((c, i) => { return <>{getZodiac(c)}{i !== userDetails.additionalInformation.expectedZodiacSigns.length - 1 && ','}&nbsp;</> })}</p>
                            </motion.div>
                            <motion.div className="grid w-96 grid-cols-2">
                                <p>Stars</p>
                                <p className="font-bold  text-primeColor">{userDetails.additionalInformation.expectedStars.map((c, i) => { return <>{getStars(c)}{i !== userDetails.additionalInformation.expectedStars.length - 1 && ','}&nbsp;</> })}</p>
                            </motion.div>
                        </motion.div>
                    </motion.div>
                    <motion.div className="h-full flex flex-row w-fit py-2 px-2 my-2">
                        <RasiKattam rasiValues={userDetails.rasiKattam} readOnly={true} />
                        <AmsaKattam amsaValues={userDetails.amsaKattam} readOnly={true} />
                    </motion.div>
                </motion.div>
            )}
        </>
    );
}

export default PreviewRegistration